import { emptyValidator, formValidator } from "../../validators";

const locationValidationConfig = {
  locType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  locName: {
    validators: [emptyValidator()],
    name: "Location Name",
  },
  locLon: {
    validators: [emptyValidator()],
    name: "Longitude",
  },
  locLat: {
    validators: [emptyValidator()],
    name: "Latitude",
  },
  locActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
  locStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
};

const locationCustomerValidationConfig = {
  lcuCustomer: {
    validators: [emptyValidator()],
    name: "Customer",
  },
  lcuActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

const locationGpsProviderValidationConfig = {
  lgpGpsProvider: {
    validators: [emptyValidator()],
    name: "GPS Provider",
  },
  lcuActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

const contactValidationStatus = {
  conType: {
    validators: [emptyValidator()],
    name: "Type",
  },
  conTitle: {
    validators: [emptyValidator()],
    name: "Title",
  },
  conName: {
    validators: [emptyValidator()],
    name: "Name",
  },
  conDepartment: {
    validators: [emptyValidator()],
    name: "Department",
  },
  conMobile: {
    validators: [emptyValidator()],
    name: "Mobile",
  },
  conEmail: {
    validators: [emptyValidator()],
    name: "Email",
  },
  conAddress: {
    validators: [emptyValidator()],
    name: "Address",
  },
  conState: {
    validators: [emptyValidator()],
    name: "State",
  },
  conDistrict: {
    validators: [emptyValidator()],
    name: "District",
  },
  conCity: {
    validators: [emptyValidator()],
    name: "City",
  },
  conCountry: {
    validators: [emptyValidator()],
    name: "Country",
  },
  conStatus: {
    validators: [emptyValidator()],
    name: "Status",
  },
  conActive: {
    validators: [emptyValidator()],
    name: "Active",
  },
};

export const locationValidation = (location) =>
  formValidator(location, locationValidationConfig);

export const locationCustomerValidation = (locationCustomer) =>
  formValidator(locationCustomer, locationCustomerValidationConfig);

export const locationGpsProviderValidation = (locationGpsProvider) =>
  formValidator(locationGpsProvider, locationGpsProviderValidationConfig);

export const locationContactValidation = (contactData) =>
  formValidator(contactData, contactValidationStatus);

const existingLocationApprovalValidationConfig = {
  lorName: {
    validators: [emptyValidator()],
    name: "Location Name",
  },
  lorCustomer: {
    validators: [emptyValidator()],
    name: "Customer",
  },
  lorLon: {
    validators: [emptyValidator()],
    name: "Longitude",
  },
  lorLat: {
    validators: [emptyValidator()],
    name: "Latitude",
  },
  lorPlant: {
    validators: [emptyValidator()],
    name: "Shipper/Plant",
  },
};

const newLocationApprovalValidationConfig = {
  lorName: {
    validators: [emptyValidator()],
    name: "Location Name",
  },
  lorCustomer: {
    validators: [emptyValidator()],
    name: "Customer",
  },
  lorLon: {
    validators: [emptyValidator()],
    name: "Longitude",
  },
  lorLat: {
    validators: [emptyValidator()],
    name: "Latitude",
  },
  lorPlant: {
    validators: [emptyValidator()],
    name: "Shipper/Plant",
  },
  lorAddress: {
    validators: [emptyValidator()],
    name: "Address",
  },
  lorCity: {
    validators: [emptyValidator()],
    name: "City",
  },
};

export const locationApprovalValidation = (approvalData, isNew) =>
  formValidator(
    approvalData,
    isNew
      ? newLocationApprovalValidationConfig
      : existingLocationApprovalValidationConfig,
  );
